import { render } from "./EnquiryDetails.vue?vue&type=template&id=407f63e4"
import script from "./EnquiryDetails.vue?vue&type=script&lang=js"
export * from "./EnquiryDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__